export interface VipClubDeps {
  isAuthenticated: Ref<boolean>
  isReady: Ref<boolean>
  vipBonusesCount: Ref<number>
}

export const [useVipClubDeps, provideVipClubDeps] =
  createEntityDeps<VipClubDeps>('vipClub')
